export interface SalesOrderHeader {
  id: string;
  orderNo: string;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  proformaOrder: string;
  proformaPaid: string;
  creditPassed: string;
  orderStatus: string;
  orderType: string;
  currency: string;
  orderValue: number;
  dateOrdered: Date;
  dateEntered: Date;
  earliestDelivery: Date;
  enteredBy: string;
  deliveryAddress: string;
  sellingCompany: string;
  salesOrderDeposits: boolean;
  colour: string;
  deliveryAddressee: string;
  pickingNotePrinted: string;
  pickingNotePrintedDate: string;
  print: boolean;
  thirdPartyDespatch: boolean;
  salesOrderConfirmed: boolean;
  salesOrderConfirmedString: string;
  canDelete: boolean;
  reserved: string;
  allocations: boolean;
}
